module.exports = __webpack_public_path__ + "static/media/PortfolioShowOff.024bd33c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PortfolioShowOff.png
// module id = 323
// module chunks = 0